export enum OrderDirections {
    ascending = 'ascending',
    descending = 'descending',
    none = '',
}
